import React, { useEffect, useState } from "react";
import {
  useGenerateBatchCodeMutation,
  useGetFruitsQuery,
  useGetSuppliersQuery,
} from "../../Receiving/unloading/unloadingApi";
import { Col, Row } from "react-bootstrap";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import Button from "../../../components/shared/buttons/button";

import {
  useCreateBrokerageMaterialMutation,
  useUpdateBrokerageMaterialMutation,
} from "./materialApi";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";
import { capitalizeFirstLetter, convertToUserTimezone, getCurrentDateTime } from "../../../helpers/Utils";

const MaterialEnteredModal = ({ show, setShow, record, mode }) => {
  // Translation
  const { _t } = useTranslator();

  // Initial Values
  const initialFormData = {
    supplier_id: "",
    fruit_type_id: "",
    fruit_type_variety: "",
    batch_code: "",
    entered_date_time: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    total_entered_kg: "",
    total_entered_cheeks_kg: "",
    total_entered_strips_kg: "",
    prime_total_kg: "",
    prime_total_fruit_cheeks_kg: "",
    prime_total_fruit_strips_kg: "",
    seconds_total_kg: "",
    seconds_total_fruit_cheeks_kg: "",
    seconds_total_fruit_strips_kg: "",
    pieces_total_kg: "",
    pasting_kg: "",
    rejected_strips_kg: "",
    rejected_cheeks_kg: "",
    rejected_kg: "",
    status: "",
  };

  // RTk Query
  const [createRawMaterial, { isLoading: isCreating }] =
    useCreateBrokerageMaterialMutation();
  const [updateRawMaterial, { isLoading: isUpdating }] =
    useUpdateBrokerageMaterialMutation();
    	
  const { data: supplierList } = useGetSuppliersQuery({ role_id: "brokerage" });
  const { data: fruitList } = useGetFruitsQuery();
  const [generateBatchCodeApi] = useGenerateBatchCodeMutation();

  // States
  const [formData, setFormData] = useState(initialFormData);

  // Effects

  useEffect(() => {
    if (mode === "edit" || mode === "view" && record) {
      const updatedFormData = { ...initialFormData };
      for (const key in record) {
        if (key in initialFormData) {
          if(key === "entered_date_time" && record[key]){
            updatedFormData[key] = convertToUserTimezone(record[key],"YYYY-MM-DDTHH:mm");
          }else{
            updatedFormData[key] = record[key];
          }
        }
      }
      // When pasting, always derive total_entered_kg from pasting_kg
      // if (updatedFormData.fruit_type_variety === "pasting" && updatedFormData.pasting_kg) {
      //   updatedFormData.total_entered_kg = parseFloat(updatedFormData.pasting_kg) || "";
      // }
      setFormData(updatedFormData);
    }
  }, [mode, record]);

  useEffect(() => {
    const fetchBatchCode = async () => {
      if (formData?.supplier_id && supplierList?.data) {
        // Supplier name
        const supplierName = supplierList?.data.find(
          (supplier) => supplier.id == formData?.supplier_id
        )?.name;

        if (supplierName) {
          try {
            // Call API to generate batch code
            const response = await generateBatchCodeApi({
              supplier_id: formData.supplier_id,
              supplierName: supplierName,
              type:"brokerage"
            }).unwrap();

            // Update form data with batch code from API
            setFormData((prevFormData) => ({
              ...prevFormData,
              batch_code: response?.data?.batch_code || "",
            }));
          } catch (error) {
            console.error("Error generating batch code:", error);
    
          }
        }
      }
    };

    if(mode == 'add'){
      fetchBatchCode();
    }
  }, [formData?.supplier_id ,mode]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (formData?.fruit_type_variety !== "pieces" &&  formData?.fruit_type_variety !== "pasting" ) {
        const totalEnteredCheeksKg = parseFloat(formData?.total_entered_cheeks_kg) || 0;
        const totalEnteredStripKg = parseFloat(formData?.total_entered_strips_kg) || 0;
        const totalEnteredKg = totalEnteredCheeksKg + totalEnteredStripKg ;

        setFormData((prev) => ({
          ...prev,
          total_entered_kg: totalEnteredKg > 0 ? totalEnteredKg : "",
        }));
      }
    }, 400);

    return () => clearTimeout(handler);
  }, [
    formData?.fruit_type_variety,
    formData?.total_entered_cheeks_kg,
    formData?.total_entered_strips_kg,
    formData?.pasting_kg,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (formData?.fruit_type_variety != "pieces") {
        const primeTotalFruitCheeksKg =
          parseFloat(formData?.prime_total_fruit_cheeks_kg) || 0;
        const primeTotalFruitStripsKg =
          parseFloat(formData?.prime_total_fruit_strips_kg) || 0;
        const primeTotalKg = primeTotalFruitCheeksKg + primeTotalFruitStripsKg;

        setFormData((prev) => ({
          ...prev,
          prime_total_kg: primeTotalKg,
        }));
      }
    }, 400);

    return () => clearTimeout(handler);
  }, [
    formData?.fruit_type_variety,
    formData?.prime_total_fruit_cheeks_kg,
    formData?.prime_total_fruit_strips_kg,
  ]);

  useEffect(() => {
    const handler = setTimeout(() => {
      const secondsTotalFruitCheeksKg =
        parseFloat(formData?.seconds_total_fruit_cheeks_kg) || 0;
      const secondsTotalFruitStripsKg =
        parseFloat(formData?.seconds_total_fruit_strips_kg) || 0;
      const secondsTotalKg =
        secondsTotalFruitCheeksKg + secondsTotalFruitStripsKg;

      setFormData((prev) => ({
        ...prev,
        seconds_total_kg: secondsTotalKg,
      }));
    }, 400);

    return () => clearTimeout(handler);
  }, [
    formData?.seconds_total_fruit_cheeks_kg,
    formData?.seconds_total_fruit_strips_kg,
  ]);

  // Functions  

  const handleClose = () => {
    setShow(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isCreating || isUpdating) {
      return false;
    }
    let updatedFormData = { ...formData };    

    updatedFormData = {
      ...updatedFormData,
      // total_entered_kg: updatedFormData?.fruit_type_variety === "pasting"
      //   ? parseFloat(updatedFormData?.pasting_kg) || 0
      //   : parseFloat(updatedFormData?.total_entered_kg) || 0,
      total_entered_cheeks_kg:
        parseFloat(updatedFormData?.total_entered_cheeks_kg) || 0,
      total_entered_strips_kg:
        parseFloat(updatedFormData?.total_entered_strips_kg) || 0,
    };

    const validationErrors = validateFormData(updatedFormData);

    if (Object.keys(validationErrors).length > 0) {
      const firstErrorMsg = Object.values(validationErrors)[0];
      toast.error(firstErrorMsg);
      return;
    }

    const mutation = mode === "add" ? createRawMaterial : updateRawMaterial;
    try {
      const payload =
        mode === "add"
          ? updatedFormData
          : { id: record.id, requestBody: updatedFormData };
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedFormData = { ...formData };
    updatedFormData[name] = value;
    if (name === "fruit_type_variety") {
      updatedFormData = {
        ...updatedFormData,
        total_entered_kg: "",
        total_entered_cheeks_kg: "",
        total_entered_strips_kg: "",
        prime_total_kg: "",
        prime_total_fruit_cheeks_kg: "",
        prime_total_fruit_strips_kg: "",
        seconds_total_kg: "",
        seconds_total_fruit_cheeks_kg: "",
        seconds_total_fruit_strips_kg: "",
        pieces_total_kg: "",
        pasting_kg: "",
        rejected_kg: "",
        rejected_strips_kg: "",
        rejected_cheeks_kg: "",
      };
    }
    setFormData(updatedFormData);
  };

  const validateFormData = (formData) => {
    const errors = {};
    const toNum = (val) => parseFloat(val || 0);

    const {
      supplier_id,
      fruit_type_id,
      fruit_type_variety,
      total_entered_kg,
      total_entered_cheeks_kg,
      total_entered_strips_kg
    } = formData;

    //  Select Supplier
    if (!supplier_id) {
      errors.supplier_id = _t("please_select_supplier", "Please select a supplier.");
      return errors; // Early return: no need to validate further
    }

    //  Select Fruit Type
    if (!fruit_type_id) {
      errors.fruit_type_id = _t("please_select_fruit_type", "Please select a fruit type.");
      return errors; // Early return: no need to validate further
    }

    //  Select Fruit Type Variety
    if (!fruit_type_variety) {
      errors.fruit_type_variety = _t("please_select_fruit_type_variety", "Please select a fruit type variety.");
      return errors; // Early return: no need to validate further
    }

    // Must be positive and non-zero
    if (!total_entered_kg || toNum(total_entered_kg) < 1) {
      errors.total_entered_kg = _t("total_entered_kg_min", "Total entered weight must be at least 1 kg. Please enter a valid amount.");
      return errors; // Early return: no need to validate further
    }

    if (fruit_type_variety === "prime" || fruit_type_variety === "seconds") {
      // check total_entered_cheeks_kg and total_entered_strips_kg
      if (
        total_entered_kg !=
        (total_entered_cheeks_kg || 0) + (total_entered_strips_kg || 0)
      ) {
        errors.total_entered_kg = _t("total_entered_kg_mismatch", "The entered weight does not match the sum of Cheeks KG and Strips KG.");
        return errors; // Early return: no need to validate further
      }
    }

    return errors;
  };

  const renderFormFields = () => (
    <>
      <Col lg={6}>
        <SelectBox
          label={_t("supplier_name", "Supplier Name")}
          type="text"
          name="supplier_id"
          value={formData.supplier_id}
          options={supplierList?.data.map((list) => ({
            value: list.id,
            label: list.name,
          }))}
          onChange={handleChange}
          disabled={mode == "view"}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("entered_date_time", "Entered Date Time")}
          type="datetime-local"
          name="entered_date_time"
          value={formData.entered_date_time}
          onChange={handleChange}
          disabled={true}
        />
      </Col>
      
      <Col lg={6}>
        <InputWithLabel
          label={_t("batch_code", "Batch Code")}
          type="text"
          name="batch_code"
          value={formData.batch_code}
          disabled={true}
          placeholder={`${_t("batch_code", "Batch Code")}...`}
        />
      </Col>
      <Col lg={3}>
        <SelectBox
          label={_t("fruit_type", "Fruit Type")}
          name="fruit_type_id"
          options={fruitList?.data.map((list) => ({
            value: list.id,
            label: list.name,
          }))}
          value={formData.fruit_type_id}
          required={false}
          onChange={handleChange}
          disabled={mode == "view"}
        />
      </Col>
      <Col lg={3}>
        <SelectBox
          label={_t("fruit_type_variety", "Fruit Type Variety")}
          name="fruit_type_variety"
          value={formData.fruit_type_variety}
          onChange={handleChange}
          options={["prime", "seconds", "pieces" ,"pasting"]?.map((val) => ({
            value: val,
            label: `${capitalizeFirstLetter(_t(val, val))}`,
          }))}
          disabled={mode == "view"}
        />
      </Col>
      
      <Col lg={12}>
        <Row>
          {(formData?.fruit_type_variety !== "pasting" ) &&  
            <Col lg={4}>
              <InputWithLabel
                label={_t("total_cheeks_kg_entered", "Total Entered Cheeks KG")}
                type="number"
                name="total_entered_cheeks_kg"
                value={formData.total_entered_cheeks_kg}
                placeholder={"0"}
                onChange={handleChange}
                disabled={
                  formData?.fruit_type_variety === "" ||
                  formData?.fruit_type_variety === "pieces" || 
                  mode == "view"
                }
              />
            </Col>
          }
          {(formData?.fruit_type_variety !== "pasting" ) &&  
            <Col lg={4}>
              <InputWithLabel
                label={_t("total_strips_kg_entered", "Total Entered Strips KG")}
                type="number"
                name="total_entered_strips_kg"
                value={formData.total_entered_strips_kg}
                placeholder={"0"}
                onChange={handleChange}
                disabled={
                  formData?.fruit_type_variety === "" ||
                  formData?.fruit_type_variety === "pieces" || 
                  mode == "view"
                }
              />
            </Col>
          }
          {/* {(formData?.fruit_type_variety !== "pasting" ) &&   */}
            <Col lg={4}>
              <InputWithLabel
                label={_t("total_weight", "Total Weight")}
                type="number"
                name="total_entered_kg"
                value={formData.total_entered_kg}
                placeholder={"0"}
                onChange={handleChange}
                disabled={(formData?.fruit_type_variety !== "pieces" &&  formData?.fruit_type_variety !== "pasting") || mode == "view" }
              />
            </Col>
          {/* } */}

          {/* {(formData?.fruit_type_variety == "pasting" ) && 
            <Col lg={4}>
              <InputWithLabel
                label={_t("total_weight_for_pasting", "Total Weight For Pasting")}
                type="number"
                name="pasting_kg"
                value={formData.pasting_kg}
                placeholder={"0"}
                onChange={handleChange}
                disabled={formData?.fruit_type_variety == "" || mode == "view" }
              />
            </Col>
          }  */}
        </Row>
      </Col>
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t("adding_brokerage_material", "Adding Brokerage Material")
          : _t("editing_brokerage_material", "Editing Brokerage Material")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      {mode !== "view"  &&
        <Row>
          <Col className="text-end">
            <Button
              label={_t("save_changes", "Save Changes")}
              size="small"
              onClick={handleSubmit}
              disabled={isCreating || isUpdating}
            />
          </Col>
        </Row>
      }
      
    </CommonModal>
  );
};

export default MaterialEnteredModal;
